<script>
  export let background = "bg-white/50"
  import Loader from "../../svg/loader.svelte"
</script>

<div class="fixed inset-0 -top-3 z-30 flex select-none flex-col items-center justify-center gap-3 rounded-md {background} backdrop-blur-md dark:bg-darkgray/50">
  <div class=" flex h-full items-center justify-center text-center text-base text-gray-400 dark:text-slate-100">
    <slot>
      <p>Loading please wait&nbsp;</p>
    </slot>

    <Loader />
  </div>
</div>
